module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7feWBz/tc-custom/9781626812390.jpg?1705577958719",
      "alt": "This image is the cover for the book Double Espresso, The Loretta Kovacs Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Double Espresso, The Loretta Kovacs Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A cast of kooky, dangerous characters worthy of Elmore Leonard or Carl Hiaasen . . . A funny, often harrowing crime novel” ("), _c('i', [_vm._v("Booklist")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In this follow-up to the Anthony Award finalist "), _c('i', [_vm._v("Devil’s Food")]), _vm._v(", fugitive-hunter Loretta Kovacs races to keep one hitman from killing another. The intended victim is a valuable government witness against the mob, and a dirty FBI agent is helping the bad guys."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Now, while she struggles to kick her caffeine habit once and for all, Loretta must fend off the advances of an amorous mob boss while babysitting the cantankerous witness in Seattle—the capital of coffee—in this “highly entertaining” caper ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Fans of comic mysteries should add Bruno to their must-read list, alongside Laurence Shames and Janet Evanovich.” —"), _c('i', [_vm._v("Booklist")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anthony Bruno\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Crime writer Anthony Bruno has published both fiction and non-fiction. He is the author of Seven (based on the hit film starring Brad Pitt and Morgan Freeman); The Iceman - The True Story of a Cold-Blooded Killerr; and The Seekers - A Bounty Hunter's Story with Joshua Armstrong.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0